const GAMESTATUS = {
    0: 'Not Started',
    1: 'In Progress',
    2: 'Game Over'
};

const GAMETYPES = {
    DIVISION: 'DIVISION',
    EPISODIC: 'EPISODIC'
};

const MINAGES = {
    DIVISION: 18,
    EPISODIC: 16
};

const TRANSACTIONTYPES = {
    EARN: 'EARN',
    BURN: 'BURN',
    SWEEPSTAKES: 'SWEEPSTAKES'
};

const PRIZETYPES = {
    SWEEPSTAKES: 'SWEEPSTAKES',
    VENDOR: 'VENDOR',
    REWARD: 'REWARD',
    ALTERNATE_PRIZES: 'ALTERNATE_PRIZES',
    FRESH_PASS: 'FRESH_PASS',
    B4U_OFFER: 'B4U_OFFER',
    RECIPE: 'RECIPE',
};

const PRIZESTATUS = {
    COMPLETED: 'COMPLETED'
};

const USEROPTEDINPROGRAM = `userOptedInPrograms`;
const STOREPROGRAMS = `storePrograms`;

const USSTATES = [
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'Delaware', value: 'DE' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' }
];

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const DAYS = (numOfDays) => Array.from({ length: numOfDays }, (_, x) => (x + 1).toString());

const YEARS = ( backYearsCount = 100 ) => {
    const year = new Date().getFullYear();
    return Array.from({length: backYearsCount}, (v, i) => year - backYearsCount + i + 1).reverse();
};

export { GAMESTATUS, GAMETYPES, MINAGES, TRANSACTIONTYPES, PRIZETYPES, PRIZESTATUS, USEROPTEDINPROGRAM, STOREPROGRAMS, USSTATES, MONTHS, DAYS, YEARS };
